import { api } from 'api';
import { call, put, SagaReturnType } from 'redux-saga/effects';
import { calculatedInternalActions } from 'store/aggregated/calculatedInternal';
import { JwtFeature } from 'utility/jwt';

import { operationWrapper } from './operationWrapper';

// Fetches day-level internal metrics (received / processed / backlog) at SubZone resolution
// and loads the calculatedInternal domain. Gated behind JwtFeature.Internal.
export function* initializeCalculatedInternals() {
  function* work(tenantId: string) {
    const {
      calculatedInternalDomain,
    }: SagaReturnType<typeof api.getCalculatedInternals> = yield call(
      api.getCalculatedInternals,
      {
        tenantId,
        resolution: 'SubZone',
        bucketResolution: 'Day',
      },
    );

    yield put(calculatedInternalActions.setDomain(calculatedInternalDomain));
  }

  yield call(operationWrapper, work, JwtFeature.Internal);
}
